"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const snowplow_js_common_1 = require("@angi/snowplow-js-common");
const usePageViewListener = () => {
    const [pageViewReady, setPageViewReady] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const handlePageView = () => {
            setPageViewReady(true);
        };
        (0, snowplow_js_common_1.addPageViewReadyEventListener)(handlePageView);
        return () => {
            (0, snowplow_js_common_1.removePageViewReadyEventListener)(handlePageView);
        };
    }, []);
    return pageViewReady;
};
exports.default = usePageViewListener;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlUGFnZVZpZXdMaXN0ZW5lci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VQYWdlVmlld0xpc3RlbmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsaUNBQTRDO0FBQzVDLGlFQUdrQztBQUVsQyxNQUFNLG1CQUFtQixHQUFHLEdBQVksRUFBRTtJQUN0QyxNQUFNLENBQUMsYUFBYSxFQUFFLGdCQUFnQixDQUFDLEdBQUcsSUFBQSxnQkFBUSxFQUFDLEtBQUssQ0FBQyxDQUFDO0lBRTFELElBQUEsaUJBQVMsRUFBQyxHQUFHLEVBQUU7UUFDWCxNQUFNLGNBQWMsR0FBRyxHQUFTLEVBQUU7WUFDOUIsZ0JBQWdCLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDM0IsQ0FBQyxDQUFDO1FBQ0YsSUFBQSxrREFBNkIsRUFBQyxjQUFjLENBQUMsQ0FBQztRQUU5QyxPQUFPLEdBQUcsRUFBRTtZQUNSLElBQUEscURBQWdDLEVBQUMsY0FBYyxDQUFDLENBQUM7UUFDckQsQ0FBQyxDQUFDO0lBQ04sQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBRVAsT0FBTyxhQUFhLENBQUM7QUFDekIsQ0FBQyxDQUFDO0FBRUYsa0JBQWUsbUJBQW1CLENBQUMifQ==


// WEBPACK FOOTER //
// ../../../../src/react/hooks/usePageViewListener.ts